import IconButton from '@mui/material/IconButton';

export function ArrowUpFrontaliere({ sx, color }) {
  return (
    <IconButton
      sx={{
        border: '1px solid',
        width: '30px',
        height: '30px',
        ...sx,
      }}
    >
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.46341 12.1194L6.46341 5.23912C6.46341 4.72513 5.86037 4.44385 5.46577 4.77167L1.33153 8.20371C0.801348 8.64283 -8.21252e-07 8.26644 -7.52898e-07 7.57842L-5.71157e-07 5.74907C-5.47032e-07 5.50624 0.107251 5.27757 0.295446 5.12378L6.15177 0.279259C6.37032 0.0991575 6.64553 6.60218e-07 6.92884 6.88364e-07L11.0691 1.09969e-06C11.3524 1.12784e-06 11.6277 0.099158 11.8462 0.279259L17.7046 5.12378C17.8907 5.27757 18 5.50827 18 5.74907L18 7.57842C18 8.26644 17.1987 8.64284 16.6685 8.20371L12.5363 4.77167C12.1396 4.44182 11.5386 4.7231 11.5386 5.23912L11.5386 13.3376L7.68566 13.3376C7.0118 13.3376 6.46745 12.7912 6.46745 12.1194L6.46341 12.1194Z"
          fill={color ? color : '#666666'}
        />
      </svg>
    </IconButton>
  );
}

export function ArrowDownFrontaliere({ sx, color }) {
  return (
    <IconButton
      sx={{
        border: '1px solid',
        width: '30px',
        height: '30px',
        transform: 'rotate(180deg)',
        ...sx,
      }}
    >
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.46341 12.1194L6.46341 5.23912C6.46341 4.72513 5.86037 4.44385 5.46577 4.77167L1.33153 8.20371C0.801348 8.64283 -8.21252e-07 8.26644 -7.52898e-07 7.57842L-5.71157e-07 5.74907C-5.47032e-07 5.50624 0.107251 5.27757 0.295446 5.12378L6.15177 0.279259C6.37032 0.0991575 6.64553 6.60218e-07 6.92884 6.88364e-07L11.0691 1.09969e-06C11.3524 1.12784e-06 11.6277 0.099158 11.8462 0.279259L17.7046 5.12378C17.8907 5.27757 18 5.50827 18 5.74907L18 7.57842C18 8.26644 17.1987 8.64284 16.6685 8.20371L12.5363 4.77167C12.1396 4.44182 11.5386 4.7231 11.5386 5.23912L11.5386 13.3376L7.68566 13.3376C7.0118 13.3376 6.46745 12.7912 6.46745 12.1194L6.46341 12.1194Z"
          fill={color ? color : '#666666'}
        />
      </svg>
    </IconButton>
  );
}

export function MedecineIcon({ color }) {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8182 11.7397C21.8182 10.1628 20.5362 8.88076 18.9592 8.88076C17.3823 8.88076 16.1003 10.1628 16.1003 11.7397C16.1003 13.109 17.0693 14.2556 18.3574 14.5324V16.2538C18.3574 19.2391 15.9288 21.6707 12.9404 21.6707C9.9521 21.6707 7.52351 19.2391 7.52351 16.2538V13.0939H8.13141C11.2823 13.0939 13.8433 10.3343 13.8433 6.94272V2.68745C13.8433 1.4536 12.8983 0.451411 11.7367 0.451411H10.4938C10.3042 0.177555 9.98821 0 9.63009 0C9.04928 0 8.5768 0.472477 8.5768 1.05329C8.5768 1.63411 9.04928 2.10658 9.63009 2.10658C9.98821 2.10658 10.3012 1.92903 10.4938 1.65517H11.7367C12.2332 1.65517 12.6395 2.11867 12.6395 2.68745V6.94272C12.6395 9.66924 10.6172 11.8902 8.13141 11.8902H5.71185C3.22608 11.8902 1.20376 9.67225 1.20376 6.94272V2.68745C1.20376 2.11867 1.61003 1.65517 2.10658 1.65517H3.34947C3.53906 1.92602 3.85505 2.10658 4.21317 2.10658C4.79398 2.10658 5.26646 1.63411 5.26646 1.05329C5.26646 0.472477 4.79398 0 4.21317 0C3.85505 0 3.54207 0.180564 3.34947 0.451411H2.10658C0.944953 0.451411 0 1.4536 0 2.68745V6.94272C0 10.3343 2.561 13.0939 5.71185 13.0939H6.31975V16.2538C6.31975 19.9042 9.29003 22.8745 12.9404 22.8745C16.5908 22.8745 19.5611 19.9042 19.5611 16.2538V14.5324C20.8492 14.2556 21.8182 13.109 21.8182 11.7397ZM18.9592 13.6958C17.8819 13.6958 17.0031 12.8171 17.0031 11.7397C17.0031 10.6623 17.8819 9.78358 18.9592 9.78358C20.0366 9.78358 20.9154 10.6623 20.9154 11.7397C20.9154 12.8171 20.0366 13.6958 18.9592 13.6958Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
}

export function ToothIcon({ color }) {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5854 12.2918C14.5854 15.2677 14.1562 18.5455 12.1335 18.5455C10.1107 18.5455 10.5183 12.8826 8.04917 12.8826C5.58004 12.8826 5.97036 18.5455 3.96486 18.5455C1.95936 18.5455 1.73078 15.2677 1.73078 12.2918C1.73078 9.31586 -2.84089 0 2.87585 0C5.98545 0 5.98545 1.13429 8.04917 1.13429C10.1129 1.13429 10.1129 0 13.2225 0C18.9392 0 14.5854 9.3137 14.5854 12.2918Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
}

export function MedecineDouceIcon({ color }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16801 19.2318C6.43201 18.2078 6.04801 17.0238 5.82401 15.8398C4.70401 16.0958 3.71201 16.4478 3.04001 16.7678C2.72001 16.9278 2.46401 17.1838 2.36801 17.5038C2.24001 17.8238 2.27201 18.1758 2.43201 18.4958C3.16801 20.0318 4.80001 22.7518 7.36001 23.6798C9.72801 24.5438 12.32 23.6798 13.952 22.9118C11.936 22.5918 8.92801 21.6958 7.20001 19.2318H7.16801Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M11.488 11.1992C10.432 10.7512 9.40801 10.4952 8.67201 10.3672C8.57601 10.3672 8.51201 10.3672 8.41601 10.3672C8.16001 10.3672 7.90401 10.4312 7.68001 10.5912C7.39201 10.7832 7.20001 11.1032 7.16801 11.4232C6.88001 13.1192 6.65601 16.2552 8.22401 18.4952C9.66401 20.5432 12.256 21.3432 14.048 21.6632C12.608 20.2552 10.624 17.7592 10.624 14.7512C10.624 11.7432 10.976 12.2872 11.488 11.2312V11.1992Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M16.928 8.35275C16.672 8.09675 16.352 7.96875 16 7.96875C15.648 7.96875 15.328 8.09675 15.072 8.35275C13.888 9.56875 11.904 12.0327 11.904 14.7528C11.904 17.4728 14.624 20.5448 15.808 21.5368C15.936 21.6328 16.096 21.6328 16.192 21.5368C17.376 20.5768 20.096 17.9848 20.096 14.7528C20.096 11.5207 18.112 9.56875 16.928 8.35275Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M23.776 18.4952C25.344 16.2552 25.12 13.1192 24.832 11.4232C24.768 11.0712 24.576 10.7832 24.32 10.5912C24.096 10.4312 23.84 10.3672 23.584 10.3672C23.328 10.3672 23.424 10.3672 23.328 10.3672C22.56 10.4952 21.536 10.7512 20.512 11.1992C21.024 12.2872 21.376 13.4712 21.376 14.7192C21.376 17.7272 19.424 20.1912 17.952 21.6312C19.744 21.3432 22.336 20.5432 23.776 18.4632V18.4952Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M29.632 17.5038C29.504 17.1838 29.28 16.9278 28.96 16.7678C28.256 16.4478 27.264 16.0638 26.176 15.8398C25.984 17.0238 25.568 18.1758 24.832 19.2318C23.104 21.6958 20.096 22.5918 18.08 22.9118C19.712 23.6798 22.304 24.5438 24.672 23.6798C27.232 22.7518 28.864 20.0318 29.6 18.4958C29.76 18.1758 29.76 17.8238 29.664 17.5038H29.632Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
}

export function HospitalisationIcon({ color }) {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8937 20.9354C23.2264 20.9354 23.4961 20.6656 23.4961 20.3329C23.4961 20.0002 23.2264 19.7305 22.8937 19.7305C22.5609 19.7305 22.2912 20.0002 22.2912 20.3329C22.2912 20.6656 22.5609 20.9354 22.8937 20.9354Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M3.01234 20.9354C3.34506 20.9354 3.61479 20.6656 3.61479 20.3329C3.61479 20.0002 3.34506 19.7305 3.01234 19.7305C2.67961 19.7305 2.40988 20.0002 2.40988 20.3329C2.40988 20.6656 2.67961 20.9354 3.01234 20.9354Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M24.3999 14.6094H1.50617C0.674763 14.6094 0 15.2841 0 16.1155V17.6217H2.56048V18.9833C1.99417 19.1731 1.58148 19.7032 1.58148 20.3328C1.58148 21.122 2.2231 21.7637 3.01233 21.7637C3.80157 21.7637 4.44319 21.122 4.44319 20.3328C4.44319 19.7032 4.0305 19.1731 3.46418 18.9833V17.6217H22.4419V18.9833C21.8756 19.1731 21.4629 19.7032 21.4629 20.3328C21.4629 21.122 22.1045 21.7637 22.8937 21.7637C23.683 21.7637 24.3246 21.122 24.3246 20.3328C24.3246 19.7032 23.9119 19.1731 23.3456 18.9833V17.6217H25.9061V16.1155C25.9061 15.2841 25.2313 14.6094 24.3999 14.6094ZM3.99134 20.3328C3.99134 20.872 3.55154 21.3118 3.01233 21.3118C2.47313 21.3118 2.03333 20.872 2.03333 20.3328C2.03333 19.7936 2.47313 19.3538 3.01233 19.3538C3.55154 19.3538 3.99134 19.7936 3.99134 20.3328ZM23.8728 20.3328C23.8728 20.872 23.433 21.3118 22.8937 21.3118C22.3545 21.3118 21.9147 20.872 21.9147 20.3328C21.9147 19.7936 22.3545 19.3538 22.8937 19.3538C23.433 19.3538 23.8728 19.7936 23.8728 20.3328Z"
        fill={color ? color : 'white'}
      />
      <path
        d="M24.3998 10.995H19.3933V2.40987H20.3271C20.5771 2.40987 20.7789 2.20804 20.7789 1.95802C20.7789 1.70799 20.5771 1.50617 20.3271 1.50617H19.3933V0.45185C19.3933 0.201826 19.1914 0 18.9414 0C18.6914 0 18.4896 0.201826 18.4896 0.45185V1.50617H15.3567V3.16295H15.2061C14.8748 3.16295 14.6037 3.43406 14.6037 3.76542V7.07899C14.6037 7.41034 14.8748 7.68145 15.2061 7.68145H15.3598C15.3598 7.68145 15.3598 7.69646 15.3598 7.7055C15.3598 7.72659 15.4471 9.73883 14.438 10.7992C14.3687 10.8715 14.2964 10.9348 14.2211 10.995H8.46753C8.81998 10.2419 8.49163 9.34422 7.73855 8.99479L4.73525 7.59408C3.98217 7.24164 3.08449 7.56996 2.73506 8.32304L2.62963 8.27487C1.87654 7.92243 0.978869 8.25075 0.629438 9.00383C0.276995 9.75692 0.60534 10.6546 1.35842 11.0041L7.50057 13.8687C7.50057 13.8687 7.51564 13.8748 7.52166 13.8778C7.57588 13.9019 7.63312 13.92 7.69035 13.9381C7.72951 13.9501 7.76867 13.9651 7.80783 13.9742C7.85302 13.9832 7.90121 13.9863 7.94941 13.9923C8.00363 13.9983 8.05484 14.0074 8.10907 14.0074C8.1181 14.0074 8.12714 14.0074 8.13618 14.0074H24.4028C25.2342 14.0074 25.909 13.3326 25.909 12.5012C25.909 11.6698 25.2342 10.995 24.4028 10.995H24.3998ZM16.2635 7.68145H16.4141C16.7454 7.68145 17.0165 7.41034 17.0165 7.07899V3.76542C17.0165 3.43406 16.7454 3.16295 16.4141 3.16295H16.2635V2.40987H18.4926V10.995H15.4321C16.3177 9.68767 16.2755 7.89232 16.2665 7.68145H16.2635Z"
        fill={color ? color : 'white'}
      />
    </svg>
  );
}

export function PointerWithArroundRounded({ color }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2569 9.35272L18.3409 9.99672C18.3409 10.0807 18.3969 10.1647 18.4809 10.1927L22.4569 12.6007C22.5969 12.6567 22.7369 12.6847 22.9049 12.6567C23.1289 12.6007 23.2969 12.4607 23.3809 12.2647L25.1449 7.98072C25.1729 7.89672 25.1449 7.81272 25.1449 7.72872L24.8369 7.16872C24.7249 6.94472 24.4169 6.97272 24.3329 7.16872L23.0169 10.3607C21.5049 6.10472 17.4449 3.16472 12.8249 3.13672C6.91692 3.16472 2.07292 8.00872 2.04492 13.9727C2.04492 16.8567 3.16492 19.6007 5.20892 21.6447C7.25292 23.6887 9.96893 24.8367 12.8529 24.8367C17.9769 24.8367 22.4289 21.1967 23.4649 16.1847C23.5489 15.7927 23.2969 15.4287 22.9329 15.3447C22.5409 15.2607 22.1769 15.5127 22.0929 15.8767C21.1969 20.2447 17.3049 23.4087 12.8529 23.4087C10.3329 23.4087 7.95292 22.4287 6.18892 20.6367C4.42492 18.8447 3.44492 16.4927 3.44492 13.9727C3.44492 8.76472 7.70092 4.56472 12.8809 4.56472C16.9409 4.56472 20.5249 7.19672 21.7849 10.9767L18.6489 9.07272C18.4529 8.96072 18.2009 9.12872 18.2289 9.35272H18.2569Z"
        fill={color ? color : '#FF305E'}
      />
      <path
        d="M12.7682 17.3606C14.6239 17.3606 16.1282 15.8563 16.1282 14.0006C16.1282 12.1449 14.6239 10.6406 12.7682 10.6406C10.9125 10.6406 9.4082 12.1449 9.4082 14.0006C9.4082 15.8563 10.9125 17.3606 12.7682 17.3606Z"
        fill={color ? color : '#FF305E'}
      />
    </svg>
  );
}

export function SendIconFrontaliere({ color }) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.8175 7.91683L20.7675 0.0868257C21.7875 -0.303174 22.8075 0.686825 22.4175 1.73683L14.5875 21.6868C14.1675 22.7668 12.6675 22.7668 12.2175 21.6868L9.6375 15.3568C9.4575 14.9368 9.5475 14.4568 9.8175 14.0968L15.5775 6.89683L8.3775 12.6568C8.0175 12.9568 7.5375 13.0168 7.1175 12.8368L0.7875 10.2568C-0.2625 9.83683 -0.2625 8.30683 0.7875 7.88683L0.8175 7.91683Z"
        fill={color ? color : '#FF305E'}
      />
    </svg>
  );
}
